import React from "react";
import style from "./index.module.scss";
import { GradeRuleModelType, jsonRegex } from "API/scoreRule";
import FormulaModeColumn from "../../../../Components/TableBody/Components/FormulaModeColumn";

const Index = ({ item }: { item: GradeRuleModelType }) => {
    const isShow = jsonRegex.test(item.formulaModeJson);

    return (
        <div className={style.root}>
            <div className={style.title}>
                {item.ruleName}&nbsp;&nbsp; <span>{item.weight}%</span>
            </div>
            <div className={style.desp}>{item.description}</div>
            {isShow && (
                <FormulaModeColumn
                    value={item.formulaModeJson}
                    isShow={isShow}
                    record={item}
                    fontStyle={{ color: "#999999", fontSize: 12 }}
                    styles={{ color: "#999999", fontSize: 12 }}
                />
            )}

            {item.remark && (
                <div className={style.remark}>备注：{item.remark}</div>
            )}
        </div>
    );
};

export default Index;
